import WebLayout from './TooltipIconLayout.web';
import MobileLayout from './TooltipIconLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
